// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_3eZeEgYO5SjTh37TPRe4bP","cancelBtn":"EgjwrIEZrMYq9dRSDMK5o","saveBtn":"_2NU0tVPx-KRSPjz0OeDpAK"};